export default "__VITE_ASSET__$tvyPR7W__"